import React, { useState, useEffect, useContext } from "react";
import organisms from "../../../components/organisms";
import { Default_Page_Limit } from "../../../constants/defaultValues";
import { HeaderHeading } from "../../../Context";
import service from "../../../api/services";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import { useToasts } from "react-toast-notifications";
import { FeedbackFormData } from "./interface";

const { FeedbackForm } = organisms;

const Index = () => {
    const { addToast } = useToasts();
    const { setHeader }: any = useContext(HeaderHeading);
    const [feedbacks, setFeedbacks] = useState<FeedbackFormData>();
    const [limitPerPage, setLimitPerPage] = useState(Default_Page_Limit);
    const [currentPage, setCurrentPage] = useState(1);

    const getFeedbacksList = async () => {
        try {
            let response = await service.eCommerceService.feedbackList({});
            if (response.status === 200) {
                setFeedbacks(response?.data);
            }
        } catch (error: any) {
            console.error(error);
            addToast(error.response.data.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };

    useEffect(() => {
        getFeedbacksList();
    }, [limitPerPage, currentPage]);

    useEffect(() => {
        setHeader("Feedback Form");
    }, []);

    return (
        <Wrapper>
            <FeedbackForm
                feedbacks={feedbacks}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setLimitPerPage={(value: number) => {
                    setLimitPerPage(value);
                    setCurrentPage(1);
                }}
                limitPerPage={limitPerPage}
            />
        </Wrapper>
    );
};

export default Index;
